import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const FolderOpen = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M13.1245 3.5H8.53518C8.20083 3.5 7.8886 3.3329 7.70313 3.0547L7.29687 2.4453C7.1114 2.1671 6.79917 2 6.46482 2H2.5C1.94772 2 1.5 2.44772 1.5 3V4.665V13L4.2196 7.78743C4.39194 7.45712 4.73361 7.25 5.10618 7.25H14.5L14.1157 4.36784C14.0495 3.87103 13.6257 3.5 13.1245 3.5Z"
          fill={color}
          fillOpacity="0.1"
        />
        <path
          d="M3.83315 7.77142C3.93255 7.46078 4.22131 7.25 4.54746 7.25H14.5487C15.0337 7.25 15.3912 7.70341 15.278 8.17503L14.184 12.7334C14.0761 13.183 13.674 13.5 13.2116 13.5H3.36995C2.69245 13.5 2.21104 12.8405 2.41753 12.1952L3.83315 7.77142Z"
          fill={color}
          fillOpacity="0.05"
        />
        <path
          d="M4 13.5H2.5C1.94772 13.5 1.5 13.0523 1.5 12.5L1.5 3.665L1.5 3C1.5 2.44772 1.94772 2 2.5 2H6.46482C6.79917 2 7.1114 2.1671 7.29687 2.4453L7.70313 3.0547C7.8886 3.3329 8.20083 3.5 8.53518 3.5H13.5C14.0523 3.5 14.5 3.94772 14.5 4.5V6.75"
          stroke={color}
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M14.3517 7.25H4.42489C4.00158 7.25 3.62413 7.51654 3.48251 7.91546L1.97376 12.1655C1.74268 12.8164 2.22542 13.5 2.91614 13.5H12.8005C13.2205 13.5 13.5958 13.2375 13.7399 12.8429L15.2911 8.59287C15.5292 7.9405 15.0462 7.25 14.3517 7.25Z"
          stroke={color}
        />
      </svg>
    )
  },
)

export default FolderOpen
